/*
 * Pipeline Theme
 *
 * Use this file to add custom Javascript to Pipeline.  Keeping your custom
 * Javascript in this fill will make it easier to update Pipeline. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 *
 */

(function () {

  document.addEventListener("theme:variant:change", function (event) {
  const variant = event.detail.variant;
  if (!variant) return;

  const selectedVariantId = variant.id;
  const inventoryBlock = document.querySelector('[id^="Inventory-"]');

  if (!inventoryBlock) return;
  const sectionId = inventoryBlock.dataset.sectionId;
  const fetchUrl = `${window.location.pathname}?variant=${selectedVariantId}&section_id=${sectionId}`;
  fetch(fetchUrl)
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const newDoc = parser.parseFromString(html, 'text/html');

      const updatedInventory = newDoc.querySelector(`#Inventory-${sectionId}`);
      const currentInventory = document.querySelector(`#Inventory-${sectionId}`);

      if (updatedInventory && currentInventory) {
        currentInventory.innerHTML = updatedInventory.innerHTML;
        currentInventory.className = updatedInventory.className;
      }
    });
});


  document.addEventListener("theme:cart:change", function (event) {
    var cart = event.detail.cart;
    if (cart) {
      // ... update an app or a custom shipping calculator
    }
  });

  document.addEventListener("theme:cart:init", (e) => {
    // console.log('theme:cart:init');
  });

})();


class slideshowSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    // Delay init to next frame so the browser has finished parsing/painting children
    requestAnimationFrame(() => this.initSwiper());
  }

  initSwiper() {
    this.sliderWrapper = this.querySelector(".slideshow__swiper");

    if (!this.sliderWrapper) {
      console.warn("No .slideshow__swiper element found inside slideshowSwiper");
      return;
    }

    // Bail out if there are no slides — Swiper crashes on empty containers
    const slides = this.sliderWrapper.querySelectorAll('.swiper-slide');
    if (!slides.length) {
      console.warn("No .swiper-slide elements found inside .slideshow__swiper — skipping init");
      return;
    }

    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }

    const centered_slides = this.sliderWrapper.dataset.centeredslides
      ? JSON.parse(this.sliderWrapper.dataset.centeredslides)
      : false;
    const effect_fade = this.sliderWrapper.dataset.effectfade
      ? JSON.parse(this.sliderWrapper.dataset.effectfade)
      : false;
    const free_mode = this.sliderWrapper.dataset.freemode
      ? JSON.parse(this.sliderWrapper.dataset.freemode)
      : false;
    const loop = this.sliderWrapper.dataset.loop
      ? JSON.parse(this.sliderWrapper.dataset.loop)
      : false;
    const autoplay_enabled = this.sliderWrapper.dataset.autoplay
      ? JSON.parse(this.sliderWrapper.dataset.autoplay)
      : false;
    const delay = this.sliderWrapper.dataset.delay
      ? parseInt(this.sliderWrapper.dataset.delay)
      : 3000;

    const next = this.querySelector(".swiper-button-next");
    const prev = this.querySelector(".swiper-button-prev");
    const pagination = this.querySelector(".swiper-pagination");
    const scroll = this.querySelector(".swiper-scrollbar");

    // Build config, only including navigation/pagination/scrollbar when elements exist
    const swiperConfig = {
      effect: effect_fade ? "fade" : "slide",
      centeredSlides: centered_slides,
      slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile) || 1,
      spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace) || 0,
      grabCursor: false,
      horizontal: true,
      watchSlidesProgress: true,
      draggable: true,
      autoHeight: false,
      watchOverflow: true,
      threshold: 10,
      freeMode: free_mode,
      loop: loop,
      speed: 700,
      mousewheel: {
        forceToAxis: true,
      },
      autoplay: {
        enabled: autoplay_enabled,
        disableOnInteraction: false,
        delay: delay,
      },
      breakpoints: {
        359: {
          slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesmobile) || 1,
          spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace) || 0,
        },
        768: {
          slidesPerView: parseFloat(this.sliderWrapper.dataset.slidestab) || 1,
          spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace) || 0,
        },
        1024: {
          slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesdesktop) || 1,
          spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace) || 0,
        },
      },
    };

    if (next && prev) {
      swiperConfig.navigation = { nextEl: next, prevEl: prev };
    }
    if (pagination) {
      swiperConfig.pagination = {
        el: pagination,
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + "</span>";
        },
      };
    }
    if (scroll) {
      swiperConfig.scrollbar = { el: scroll, draggable: true };
    }

    try {
      this.swiperInstance = new Swiper(this.sliderWrapper, swiperConfig);
    } catch (e) {
      console.warn("Swiper failed to initialize on .slideshow__swiper:", e.message);
    }
  }
}

customElements.define("slideshow-swiper", slideshowSwiper);


/* =============================================
   FIX 1: verticalSwiper — added null guard
   ============================================= */
class verticalSwiper extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sliderWrapper = this.querySelector(".vertical-slider");

    // FIX: Guard against missing element
    if (!this.sliderWrapper) {
      console.warn("No .vertical-slider element found inside verticalSwiper");
      return;
    }

    let centered_slides =
      this.sliderWrapper.dataset.centeredslides !== undefined
        ? JSON.parse(this.sliderWrapper.dataset.centeredslides)
        : false;
    let effect_fade =
      this.sliderWrapper.dataset.effectfade !== undefined
        ? JSON.parse(this.sliderWrapper.dataset.effectfade)
        : false;

    let next = this.querySelector(".swiper-button-next");
    let prev = this.querySelector(".swiper-button-prev");
    let pagination = this.querySelector(".swiper-pagination");
    let scroll = this.querySelector(".swiper-scrollbar");

    const swiperConfig = {
      effect: effect_fade ? "fade" : "slide",
      centeredSlides: centered_slides,
      slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile) || 1,
      spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace) || 0,
      grabCursor: false,
      direction: 'vertical',
      freeMode: JSON.parse(this.sliderWrapper.dataset.freemode || 'false'),
      loop: JSON.parse(this.sliderWrapper.dataset.loop || 'false'),
      speed: 700,
      autoplay: {
        enabled: JSON.parse(this.sliderWrapper.dataset.autoplay || 'false'),
        disableOnInteraction: false,
        delay: parseInt(this.sliderWrapper.dataset.delay) || 3000,
      },
      breakpoints: {
        359: {
          direction: 'horizontal',
          spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace) || 0,
          slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile) || 1,
        },
        768: {
          direction: 'horizontal',
          spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace) || 0,
          slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile) || 1,
        },
        1024: {
          direction: 'vertical',
          spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace) || 0,
          slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile) || 1,
        },
      },
    };

    if (next && prev) {
      swiperConfig.navigation = { nextEl: next, prevEl: prev };
    }
    if (pagination) {
      swiperConfig.pagination = {
        el: pagination,
        clickable: true,
        renderBullet: function (index, className) {
           return '<span class="' + className + '">' + (index + 1) + "</span>";
         },
      };
    }
    if (scroll) {
      swiperConfig.scrollbar = { el: scroll, draggable: true };
    }

    const swiper = new Swiper(this.sliderWrapper, swiperConfig);
  }
}
customElements.define("swiper-vertical", verticalSwiper);


/* =============================================
   FIX 2: thumbnailSlider — added null guard
   and scoped selector to this element
   ============================================= */
class thumbnailSlider extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.sliderWrapper = this.querySelector(".slider-content");

    // FIX: Guard against missing element
    if (!this.sliderWrapper) {
      console.warn("No .slider-content element found inside thumbnailSlider");
      return;
    }

    let next = this.querySelector(".swiper-button-next");
    let prev = this.querySelector(".swiper-button-prev");
    let pagination = this.querySelector(".swiper-pagination");
    let scroll = this.querySelector(".swiper-scrollbar");

    // FIX: Use this.sliderWrapper instead of global ".slider-content" selector
    // so multiple instances on one page don't collide
    const sliderContentConfig = {
      loop: false,
      slidesPerView: 1,
      freeMode: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      spaceBetween: parseInt(this.sliderWrapper.dataset.space) || 0,
      allowTouchMove: true,
      speed: 700,
      autoplay: {
        enabled: JSON.parse(this.sliderWrapper.dataset.autoplay || 'false'),
        disableOnInteraction: false,
        delay: parseInt(this.sliderWrapper.dataset.delay) || 3000,
      },
    };

    if (next && prev) {
      sliderContentConfig.navigation = { nextEl: next, prevEl: prev };
    }
    if (pagination) {
      sliderContentConfig.pagination = {
        el: pagination,
        clickable: true,
        renderBullet: function (index, className) {
           return '<span class="' + className + '">' + (index + 1) + "</span>";
         },
      };
    }
    if (scroll) {
      sliderContentConfig.scrollbar = { el: scroll, draggable: true };
    }

    var sliderContent = new Swiper(this.sliderWrapper, sliderContentConfig);

    // FIX: Scope to this element instead of global selector
    var sliderImageEl = this.querySelector('.slider-image');
    if (!sliderImageEl) {
      console.warn("No .slider-image element found inside thumbnailSlider");
      return;
    }

    var sliderImage = new Swiper(sliderImageEl, {
      spaceBetween: parseInt(this.sliderWrapper.dataset.space) || 0,
      slidesPerView: 1,
      loop: false,
      freeMode: false,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      slideToClickedSlide: true,
      autoplay: {
        enabled: JSON.parse(this.sliderWrapper.dataset.autoplay || 'false'),
        disableOnInteraction: false,
        delay: parseInt(this.sliderWrapper.dataset.delay) || 3000,
      },
      thumbs: {
        swiper: sliderContent
      }
    });

    sliderContent.on("slideChangeTransitionStart", function () {
      sliderImage.slideTo(sliderContent.activeIndex);
    });
    sliderImage.on("transitionStart", function () {
      sliderContent.slideTo(sliderImage.activeIndex);
    });
  }
}
customElements.define("thumbnails-swiper", thumbnailSlider);


class LookModalSlider extends HTMLElement {
  constructor() {
    super();
    this.hotspots = null;
    this.modal = null;
    this.pagination = null;
    this.closeBtn = null;
    this.lookSlider = null;
    this.activeIndex = 0;
    this.isMobile = false;
  }

  connectedCallback() {
    this.hotspots = this.querySelectorAll('.look__dot__holder');
    this.modal = this.querySelector('.look-flex__inner--product');
    this.pagination = this.querySelector(".swiper-pagination");
    this.closeBtn = this.querySelector('.look__holder__close');

    if (!this.modal || !this.hotspots.length || !this.pagination) {
      console.warn('LookModalSlider: Required elements not found inside component');
      return;
    }

    this.updateIsMobile();

    window.addEventListener('resize', () => this.updateIsMobile());

    this.lookSlider = new Swiper(this.querySelector('.look__slider'), {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      pagination: {
        el: this.pagination,
        clickable: true,
        renderBullet: (index, className) =>
          `<span class="${className}">${index + 1}</span>`,
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    });

    if (!this.isMobile) {
      this.modal.classList.add('is-expanded');
      this.hotspots[this.activeIndex].classList.add('is-active');
      this.lookSlider.slideToLoop
        ? this.lookSlider.slideToLoop(this.activeIndex)
        : this.lookSlider.slideTo(this.activeIndex + this.lookSlider.loopedSlides, 0, false);
    }

    this.hotspots.forEach(hotspot => {
      hotspot.addEventListener('click', () => {
        const index = parseInt(hotspot.dataset.index, 10);

        if (hotspot.classList.contains('is-active')) {
          this.closeModal();
        } else {
          this.hotspots.forEach(h => h.classList.remove('is-active'));
          hotspot.classList.add('is-active');
          this.activeIndex = index;
          this.modal.classList.add('is-expanded');
          this.lookSlider.slideToLoop
            ? this.lookSlider.slideToLoop(index)
            : this.lookSlider.slideTo(index);
        }
      });
    });

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.closeModal());
    }
  }

  updateIsMobile() {
    const prevMobile = this.isMobile;
    this.isMobile = window.innerWidth <= 768;

    if (!prevMobile && this.isMobile) {
      this.modal.classList.remove('is-expanded');
      this.hotspots.forEach(h => h.classList.remove('is-active'));
      this.activeIndex = 0;
    }

    if (prevMobile && !this.isMobile) {
      const anyActive = Array.from(this.hotspots).some(h => h.classList.contains('is-active'));
      if (!anyActive) {
        this.hotspots[0].classList.add('is-active');
        this.modal.classList.add('is-expanded');
        this.activeIndex = 0;
        this.lookSlider.slideToLoop
          ? this.lookSlider.slideToLoop(this.activeIndex)
          : this.lookSlider.slideTo(this.activeIndex + this.lookSlider.loopedSlides, 0, false);
      }
    }
  }

  closeModal() {
    this.modal.classList.remove('is-expanded');
    this.hotspots.forEach(h => h.classList.remove('is-active'));
    this.activeIndex = 0;
    this.lookSlider.slideToLoop
      ? this.lookSlider.slideToLoop(this.activeIndex)
      : this.lookSlider.slideTo(this.activeIndex);
  }
}

customElements.define('look-modal-slider', LookModalSlider);


function openClientbook() {
  var btn = document.getElementById('clbkwc_btn_id');
  if (btn) {
    btn.click();
  } else {
    setTimeout(openClientbook, 500);
  }
}

// Accessibility fix for Clientbook chat button
setTimeout(function() {
  var chatBtn = document.getElementById('clbkwc_btn_id');
  if (chatBtn) {
    chatBtn.setAttribute('aria-label', 'Open live chat');
  }
}, 2000);

// Accessibility fixes for Seers CMP cookie banner
(function() {
  var observer = new MutationObserver(function() {
    var banner = document.getElementById('seers-cmp-cookie-data-hol');
    if (banner && banner.style.display === 'flex') {
      var firstBtn = banner.querySelector('[tabindex="0"]');
      if (firstBtn) {
firstBtn.focus({ preventScroll: true });      }

      var seersLink = banner.querySelector('a[href$="seers.ai"]');
      if (seersLink) {
        seersLink.setAttribute('aria-label', 'Cookie management');
      }

      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true, attributes: true });
})();

// Cart drawer focus management
document.addEventListener('theme:cart:change', function() {
  setTimeout(function() {
    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (drawer && !drawer.classList.contains('display-none')) {
      var firstFocus = drawer.querySelector('[data-first-focus]');
      if (firstFocus) {
        firstFocus.focus();
      }
    }
  }, 300);
});

// Fix missing alt on video poster images
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('video > img:not([alt])').forEach(function(img) {
    img.setAttribute('alt', '');
  });
});

// Fix aria-hidden-focus on Flickity carousels
function fixCarouselFocus() {
  document.querySelectorAll('[aria-hidden="true"] [data-carousel-slide], [aria-hidden="true"][data-carousel-slide]').forEach(function(slide) {
    slide.querySelectorAll('a, button, input, [tabindex]').forEach(function(el) {
      if (el.getAttribute('tabindex') !== '-1') {
        el.setAttribute('tabindex', '-1');
        el.setAttribute('data-was-focusable', 'true');
      }
    });
  });
  document.querySelectorAll('[aria-hidden="false"] [data-carousel-slide], :not([aria-hidden]) [data-carousel-slide]').forEach(function(slide) {
    slide.querySelectorAll('[data-was-focusable]').forEach(function(el) {
      el.removeAttribute('tabindex');
      el.removeAttribute('data-was-focusable');
    });
  });
}

var observer = new MutationObserver(fixCarouselFocus);
document.addEventListener('DOMContentLoaded', function() {
  fixCarouselFocus();
  document.querySelectorAll('[data-carousel], .flickity-enabled').forEach(function(carousel) {
    observer.observe(carousel, { attributes: true, attributeFilter: ['aria-hidden'], subtree: true });
  });
});